import React, { createContext, useReducer, useMemo } from "react";
import PropTypes from "prop-types";

// config
import getDefaultState from "../context/stateHelpers/getDefaultState";
import getAuthMenuVisibility from "../context/getAuthMenuVisibility";

// store
import { reducer } from "../context/store";

// context
import { useAuth } from "frontend/hooks/useAuth";
import { useMyModerator } from "frontend/components/fort/mod/photos/hooks/useMyModerator.js";
import { useViewport } from "js/hooks/useViewport";

// components
import MountingWrapper from "../components/MountingWrapper";

/*---------------------------
| Context
---------------------------*/
export const SiteHeaderContext = createContext();
SiteHeaderContext.displayName = "SiteHeader"; // Display Name

// component
export const SiteHeaderProvider = ({
    children,
    isDarkMode = false,
    hasDedlayedSecondRow = false,
    currentPage,
    ssrCookies = {},
    isLegacyPage = false
}) => {
    const viewport = useViewport();
    const { isLoggedIn, currentUser, confirmAuth, isLoading } = useAuth() || {};
    const { myModProfile: myPhotoModProfile } = useMyModerator() || {};
    const authMenuVisibilitiy = getAuthMenuVisibility(
        currentUser,
        myPhotoModProfile
    );

    const nonStateProps = {
        viewport,
        currentPage,
        isDarkMode,
        hasDedlayedSecondRow,
        isLoggedIn,
        isLoading,
        currentUser,
        confirmAuth,
        myPhotoModProfile,
        authMenuVisibilitiy,
        isLegacyPage
    };

    const stateProps = getDefaultState(
        currentPage,
        isLoggedIn,
        currentUser,
        ssrCookies
    );

    // Whatever you want to manage as internal state
    const [state, dispatch] = useReducer(reducer, stateProps);

    // useMemo so it does not pass value on every render
    const value = useMemo(() => ({ state, dispatch, nonStateProps }), [
        state,
        dispatch,
        nonStateProps
    ]);
    return (
        <SiteHeaderContext.Provider value={value}>
            <MountingWrapper>{children}</MountingWrapper>
        </SiteHeaderContext.Provider>
    );
};

export default SiteHeaderProvider;

// prop-types
const inputElementInstance =
    typeof HTMLInputElement !== "undefined" ? HTMLInputElement : () => {};

SiteHeaderProvider.propTypes = {
    children: PropTypes.any,
    isDarkMode: PropTypes.bool,
    hasDedlayedSecondRow: PropTypes.bool,
    currentPage: PropTypes.string,
    ssrCookies: PropTypes.object,
    isLegacyPage: PropTypes.bool
};
